<section class="table-content">

  <div class="filters">
    <input (input)="getAcademicYears('search', search)" [(ngModel)]="search" type="search" name="search" id="search"
           placeholder="Search name, username...">

    <div>
      @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
        <select (change)="getAcademicYears('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                id="schoolId">
          <option value="" disabled>Select a school</option>
          <option value="">All Schools</option>


          @for (s of schools()?.payload; track $index) {
            <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
          }

        </select>
      }

      <select (change)="getAcademicYears('status', filterStatus)" [(ngModel)]="filterStatus" name="filterStatus"
              id="filterStatus">
        <option value="" hidden disabled>Select a status</option>
        <option value="">All Statuses</option>


        @for (s of validStatuses; track s) {
          <option [value]="s">{{ Helpers.toSentenceCase(s) }}</option>
        }
      </select>
    </div>
  </div>

    @if (loggedUserRole !== 'SUPER-ADMIN') {
      <div class="table-wrapper">
        <table>
        <thead>
        <tr>
          <th>YEAR ID</th>
          <th>YEAR NAME</th>
          <th>START DATE</th>
          <th>END DATE</th>
          <th>STATUS</th>
          <th class="options-column">ACTIONS</th>
        </tr>
        </thead>

        <tbody>
          @if (isFiltering()) {
            <td colspan="6">
              <app-loading-indicator />
            </td>
          } @else {
            @if (!academicYears()?.payload?.length) {
              <tr>
                <td colspan="6" class="empty">
                  <app-not-found-error>
                    NO ACADEMIC YEARS FOUND
                  </app-not-found-error>
                </td>
              </tr>
            } @else {
              @for (u of academicYears()?.payload; track u.id) {
                <tr>
                  <td>
                    {{ u.public_id }}
                  </td>

                  <td>
                    {{ u.name }}
                  </td>

                  <td>
                    <p>
                      {{ Helpers.formatDate(u.start_date) }}
                    </p>
                  </td>

                  <td>
                    <p>
                      {{ Helpers.formatDate(u.end_date) }}
                    </p>
                  </td>

                  <td class="status">
                    <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                  </td>

                  <td class="options-column">
                    @if (settingCurrentYearId() === u.id) {
                      <app-loading-indicator />
                    } @else {
                      <app-action-button>
                        <button class="menu-item" (click)="selectAcademicYear('edit', u )">Edit Academic Year</button>

                        <button class="menu-item" (click)="selectAcademicYear('status', u)">Change status</button>

                        @if (u.status === 'ACTIVE' && !u.current_academic_year) {
                          <button class="menu-item" (click)="setCurrentAcademicYear(u)">Set as current academic year</button>
                        }
                      </app-action-button>
                    }
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
      </div>

      <app-pagination
        [page]="academicYears()?.pagination?.page ?? 0"
        [size]="academicYears()?.pagination?.size ?? 10"
        [totalElements]="academicYears()?.pagination?.totalElements ?? 0"
        [totalPages]="academicYears()?.pagination?.totalPages ?? 0"
        [first]="academicYears()?.pagination?.first ?? true"
        [last]="academicYears()?.pagination?.last ?? false"
        [hasNext]="academicYears()?.pagination?.hasNext ?? false"
        [hasPrevious]="academicYears()?.pagination?.hasPrevious ?? false"
        (pageChange)="loadPage($event)">
      </app-pagination>
    } @else {

      <div class="table-wrapper">
        <table>
          <thead>
          <tr>
            <th>YEAR ID</th>
            <th>YEAR NAME</th>
            <th>START DATE</th>
            <th>END DATE</th>
            <th>STATUS</th>
            <th class="options-column">ACTIONS</th>
          </tr>
          </thead>

          <tbody>
            @if (isFiltering()) {
              <td colspan="6">
                <app-loading-indicator />
              </td>
            } @else {
              @if (!academicYears()?.payload?.length) {
                <tr>
                  <td colspan="6" class="empty">
                    <app-not-found-error>
                      NO ACADEMIC YEARS FOUND
                    </app-not-found-error>
                  </td>
                </tr>
              } @else {
                @for (u of academicYears()?.payload; track u.id) {
                  <tr>
                    <td>
                      {{ u.public_id }}
                    </td>

                    <td>
                      {{ u.name }}
                    </td>

                    <td>
                      <p>
                        {{ Helpers.formatDate(u.start_date) }}
                      </p>
                    </td>

                    <td>
                      <p>
                        {{ Helpers.formatDate(u.end_date) }}
                      </p>
                    </td>

                    <td class="status">
                      <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                    </td>

                    <td class="options-column">
                      @if (settingCurrentYearId() === u.id) {
                        <app-loading-indicator />
                      } @else {
                        <app-action-button>
                          <button class="menu-item" (click)="selectAcademicYear('edit', u )">Edit Academic Year</button>

                          <button class="menu-item" (click)="selectAcademicYear('status', u)">Change status</button>

                          @if (u.status === 'ACTIVE' && !u.current_academic_year) {
                            <button class="menu-item" (click)="setCurrentAcademicYear(u)">Set as current academic year</button>
                          }
                        </app-action-button>
                      }
                    </td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>
      </div>

      <app-pagination
        [page]="academicYears()?.pagination?.page ?? 0"
        [size]="academicYears()?.pagination?.size ?? 10"
        [totalElements]="academicYears()?.pagination?.totalElements ?? 0"
        [totalPages]="academicYears()?.pagination?.totalPages ?? 0"
        [first]="academicYears()?.pagination?.first ?? true"
        [last]="academicYears()?.pagination?.last ?? false"
        [hasNext]="academicYears()?.pagination?.hasNext ?? false"
        [hasPrevious]="academicYears()?.pagination?.hasPrevious ?? false"
        (pageChange)="loadPage($event)">
      </app-pagination>
    }
  </section>


  @if (changeStatus()) {
    <section class="pop-up">
      <div class="bg" (click)="changeStatus.set(false)"></div>

      <form #changeStatusForm="ngForm" (ngSubmit)="editAcademicYearFn(changeStatusForm, 'status')">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path> <path d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path> <path d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path> <path d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
          </div>
          <div>
            <h6>Change Status</h6>
            <small>Updating status of {{ selectedAcademicYear.name }}</small>
          </div>
        </div>

        <div class="form-container">
          <div class="status">
            <small>Current status:</small>
            <p [ngClass]="selectedAcademicYear.status">{{ selectedAcademicYear.status }}</p>
          </div>

          <div>
            <label for="status">New Status <span class="required-check">*</span></label>
            <select required [(ngModel)]="status" name="status" id="status">
              <option value="" hidden disabled>Select a status</option>

              @for (s of validStatuses; track $index) {
                @if (s !== selectedAcademicYear.status) {
                  <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
                }
              }
            </select>
          </div>

          <button class="secondary-button" [disabled]="changeStatusForm.invalid" type="submit">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Change status
            }
          </button>

        </div>
      </form>
    </section>
  }

  @if (editAcademicYear()) {
    <section class="pop-up">
      <div class="bg" (click)="editAcademicYear.set(false)"></div>

      <form #academicYearForm="ngForm" (ngSubmit)="editAcademicYearFn(academicYearForm, 'edit')">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 318.331 318.331" xml:space="preserve"
                 stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path
                d="M310.331,305.092H8c-4.418,0-8-3.582-8-8V109.059c0-4.418,3.582-8,8-8s8,3.582,8,8v180.033h286.331V109.059 c0-4.418,3.582-8,8-8s8,3.582,8,8v188.033C318.331,301.51,314.749,305.092,310.331,305.092z M261.634,269.336h-18.242 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.242c4.418,0,8,3.582,8,8S266.052,269.336,261.634,269.336z M143.252,269.336h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,269.336,143.252,269.336z M74.941,269.336H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,269.336,74.941,269.336z M279.877,239.262h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S284.295,239.262,279.877,239.262z M211.565,239.262H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,239.262,211.565,239.262z M143.252,208.234h-36.485 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S147.67,208.234,143.252,208.234z M74.941,208.234H38.455 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.486c4.418,0,8,3.582,8,8v30.073 C82.941,204.653,79.359,208.234,74.941,208.234z M46.455,192.234h20.486v-14.073H46.455V192.234z M211.565,178.161H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,178.161,211.565,178.161z M279.877,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C287.877,143.551,284.295,147.132,279.877,147.132z M251.392,131.132h20.485v-14.073h-20.485V131.132z M143.252,147.132h-36.485 c-4.418,0-8-3.582-8-8v-30.073c0-4.418,3.582-8,8-8h36.485c4.418,0,8,3.582,8,8v30.073 C151.252,143.551,147.67,147.132,143.252,147.132z M114.767,131.132h20.485v-14.073h-20.485V131.132z M211.565,117.059H175.08 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.485c4.418,0,8,3.582,8,8S215.983,117.059,211.565,117.059z M74.941,117.059H38.455 c-4.418,0-8-3.582-8-8s3.582-8,8-8h36.486c4.418,0,8,3.582,8,8S79.359,117.059,74.941,117.059z M310.331,82.385H8 c-4.418,0-8-3.582-8-8V33.33c0-4.418,3.582-8,8-8h18.171c4.418,0,8,3.582,8,8s-3.582,8-8,8H16v25.056h286.331V41.33h-10.226 c-4.418,0-8-3.582-8-8s3.582-8,8-8h18.226c4.418,0,8,3.582,8,8v41.056C318.331,78.804,314.749,82.385,310.331,82.385z M266.919,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C274.919,49.839,271.337,53.42,266.919,53.42z M51.413,53.42c-4.418,0-8-3.582-8-8V21.239c0-4.418,3.582-8,8-8s8,3.582,8,8V45.42C59.413,49.839,55.831,53.42,51.413,53.42z M242.53,41.33H77.055c-4.418,0-8-3.582-8-8s3.582-8,8-8H242.53c4.418,0,8,3.582,8,8S246.948,41.33,242.53,41.33z"></path> </g></svg>
          </div>
          <div>
            <h6>Update an Academic Year</h6>
            <small>Adjust Academic Year details</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="academicYearName">Academic Year Name <span class="required-check">*</span></label>
            <input required [(ngModel)]="academicYearName" type="text" name="academicYearName" id="academicYearName"
                   placeholder="eg. 2026/2027">
          </div>

          <div class="form-group">
            <div>
              <label for="startDate">Start Date <span class="required-check">*</span></label>
              <input required [(ngModel)]="startDate" type="date" name="startDate" id="startDate">
            </div>

            <div>
              <label for="endDate">End Date <span class="required-check">*</span></label>
              <input required [(ngModel)]="endDate" type="date" name="endDate" id="endDate">
            </div>
          </div>

          <button class="secondary-button" [disabled]="academicYearForm.invalid">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Update details
            }
          </button>
        </div>

      </form>
    </section>
  }
